import styled from "styled-components";

// Form input fields
export const Input = styled.input`
  width: 100%;
  padding: 5px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: #007bff;
  }
`;
export const FormLabel = styled.label`
font-size:13.3333px;
font-weight:500;
`;
export const Label = styled.label`
 font-size:1.2rem;
 font-weight:500;
 color:${(props) => props.theme.colors.primary};
`;
export const LabelWrapper = styled.div`
 text-align:left;
 margin-bottom:5px;
`;